import { useMemo } from 'react';
import { cleanEffectiveDateTime } from '../../utils/preview-mode-utils';
import { useCustomerContextGet } from './useCustomerContextGet';
import { useSSRPreviewMode } from './useSSRPreviewMode';
import { useServerEffectiveDateTime } from './useServerEffectiveDateTime';

export const useEffectiveDateTime = (): string => {
    const serverEffectiveDateTime = useServerEffectiveDateTime();
    const isSSRPreviewMode = useSSRPreviewMode();
    const shopperContext = useCustomerContextGet();
    const effectiveDateTime = useMemo(() => {
        if (!isSSRPreviewMode) {
            return '';
        }
        if (serverEffectiveDateTime) {
            return serverEffectiveDateTime;
        }
        if (shopperContext.data?.effectiveDateTime) {
            return cleanEffectiveDateTime(shopperContext.data.effectiveDateTime);
        }
        return '';
    }, [isSSRPreviewMode, serverEffectiveDateTime, shopperContext.data?.effectiveDateTime]);
    return effectiveDateTime;
};
